import React from "react";
import "../../App.css";
import "../../bootstrap.css";
import {
  greenDot,
  viewMore,
  trialscopeFaviLogo,
} from "../../features/theme/icons";

const TSCard = (props) => {
  const {
    phase,
    condition,
    locationCount,
    locationZipcode,
    title,
    description,
    trialSponsor,
    trialsGoal,
    onTSCardClick,
    nctId,
  } = props;
  return (
    <div
      onClick={() => onTSCardClick(nctId)}
      style={{
        filter: "drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.15))",
        cursor: "pointer",
      }}
      className="card border rounded py-3 pl-3 mx-0 my-3"
    >
      <div className="row d-flex align-items-start justify-content-between">
        <div>
          <img className="mx-2" src={greenDot} alt="greendot"></img>
          <span className="mx-1">{phase}</span>
          <span className="mx-1">{"|"}</span>
          {condition && condition.length > 0 ? (
            condition.length < 2 ? (
              JSON.parse(condition).map((disease, i) => (
                <span key={i} className="mx-1">
                  {disease}
                </span>
              ))
            ) : (
              <span>{`${JSON.parse(condition)[0]}, ${
                JSON.parse(condition).length - 1
              } more ...`}</span>
            )
          ) : (
            <span className="mx-1">{"None"}</span>
          )}
        </div>
        <div className="m-1 mr-5">
          <img
            src={trialscopeFaviLogo}
            alt="tsfavicon"
            className="ptrlogo"
          ></img>
          <div className="partnertext">{"https://www.trialscope.com/"}</div>
          {/* <img src={bookmark_inactive} alt="select tag"></img> */}
        </div>
      </div>
      <div className="row card_description">
        <div className="col-sm-12 col-md-8 col-lg-8">
          <h3 className="my-3">{title}</h3>
          <p className="my-3">{description}</p>
        </div>
        <div className="card_location col-md-3 col-lg-3 col-sm-11">
          <div className="card_right_border border-bottom mb-1">
            <h4>LOCATION</h4>
            <h5>
              <span>{locationCount}</span> locations near the US, zip code{" "}
              <span>{locationZipcode}</span>
            </h5>
          </div>
          <div className="card_right_border border-bottom mb-1">
            <h4>Gender</h4>
            <h5>{trialsGoal}</h5>
          </div>
          <div className="mb-1">
            <h4>Status</h4>
            <h5>{trialSponsor}</h5>
          </div>
        </div>
        <div className="col-sm-1 col-md-1 col-lg-1 p-0 m-0 mt-5 d-flex align-items-center justify-content-end">
          <img className="mt-5" src={viewMore} alt="view more"></img>
        </div>
      </div>
    </div>
  );
};

export default TSCard;
